import { Price } from '@noths/polaris-dev-ts-types';

const defaults: Readonly<Price> = {
  currency: 'GBP',
  amount: 0,
};

export const priceBuilder = (price?: Partial<Price>): Readonly<Price> => ({
  ...defaults,
  ...price,
});
